import { useEffect, useState } from "react";
import { updatedCustomerAddress, getCustomerAddress } from "../../../lib/api";
import "./addAdressListing.css";
import { Address } from "../../../types/profile";
import { useDispatch, useSelector } from "react-redux";
import { openAddAnotherAddress, openAddressFromMap } from "../../../store/slices/modalSlice";
import AddAnotherAddressModel from "../../addAnotherAddress/AddAnotherAddress";
import AddDetailModel from "../../AddDetail/AddDetailModel";
import AddressFromMap from "../../selectAddressFromMapModel/AddressFromMap";
import { Modal } from "react-bootstrap";
import PreLoader from "../../preloader/PreLoader";

interface DeleteConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  onClose,
  onConfirm,
}) => {
  return (
    <Modal show={true} onHide={onClose} centered backdrop="static" 
        className="mb-fix slide-from-bottom ">
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body className="rounded-top">
        <div className="d-flex flex-column h-100">
          <div>
            <img
              src="https://goodhand.b-cdn.net/Assets/Flow/delte.svg"
              alt=""
              className="mx-auto d-block mb-2"
            />
            <p className="text-center font-13 text-dark ff-medium">
              Are you sure, you want to delete ?
            </p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="p-0 border-0 rounded-0 shadow-none border-top modal-footer rounded-bottom">
        <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2 gap-3">
          <button
            className="btn btn-primary bg-2 w-100 font-14 ff-semibold py-2 text-black"
            onClick={onClose}
          >
            NO
          </button>
          <button
            className="btn btn-primary w-100 font-14 ff-semibold py-2 bg-red text-white"
            onClick={onConfirm}
          >
            YES, DELETE
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

const AddressListing = () => {
  const dispatch = useDispatch();
  
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [selectedDeleteId, setSelectedDeleteId] = useState<number | null>(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const showAddAddress = useSelector((state: any) => state.modal.addAnotherAddress);
  const showAddAddressFromMap = useSelector((state: any) => state.modal.addressFromMap);
  const showDetailModel = useSelector((state: any) => state.modal.addDetailModel);
  const addressFromMap = useSelector((state: any) => state.modal.addressFromMap);

  const fetchAddressData = async () => {
    try {
      setLoading(true);
      const response = await getCustomerAddress({});
      const billingAddress = response?.mainAddressList?.billingAddress || [];
      setAddresses(billingAddress);
    } catch (error) {
      console.error("Failed to fetch addresses", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAddressData();
  }, []);
  
  useEffect(() => {
    if (!addressFromMap) {
      fetchAddressData();
    }
  }, [addressFromMap]);


  const handleDeleteAddress = async () => {
    if (selectedDeleteId !== null) {
      try {
        const findAddress = addresses.find((item: Address) => item.RecordId === selectedDeleteId);
        if (!findAddress) return;

        const updatedAddress = { ...findAddress, status: 0 };
        const response = await updatedCustomerAddress(updatedAddress);
        if (response) {
          setAddresses((prev) => prev.filter((add) => add.RecordId !== selectedDeleteId));
        }
      } catch (error) {
        console.error("Failed to delete:", error);
      } finally {
        setShowConfirmModal(false);
        setSelectedDeleteId(null);
      }
    }
  };

  const updatePrimaryAddress = async (recordId: number) => {
    try {
      const findAddress = addresses.find((item: Address) => item.RecordId === recordId);
      if (!findAddress) return;

      const updatedPrimaryAddress = {
        ...findAddress,
        primaryAddress: 1,
        status: 1,
      }
      const response = await updatedCustomerAddress(updatedPrimaryAddress);
      if (response) {
        setAddresses((prev) =>
          prev.map((addr) => ({
            ...addr,
            primaryAddress: addr.RecordId === recordId ? 1 : 0,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to update primary address:", error);
    }
  };

  const handleOpenEditModal = (val: string, id: number) => {
    const filteredData = addresses.filter((item) => item.RecordId === id);
    if (filteredData.length > 0) {
      localStorage.setItem("filteredData", JSON.stringify(filteredData[0])); // Assuming you want to store the first match
    }
    if (val === "Edit") {
      sessionStorage.setItem("mode", "Edit");
      dispatch(openAddressFromMap());
    }
  };

  const renderAddressCard = (address: Address, isPrimary: boolean) => (
    <div className="p-3 layout-border rounded-3 mb-3" key={address.RecordId}>
      <div className="d-flex justify-content-between align-items-start">
        {/* Left */}
        <div className="d-flex">
          <div className="d-flex align-items-center justify-content-center bg-3 rounded" style={{ width: "48px", height: "48px", marginRight: "12px" }}>
            <img src="https://goodhand.b-cdn.net/Assets/cart/cart-flow/adress.svg" alt="" />
          </div>
          <div>
            <p className="ff-semibold text-black mb-1">{address.addresNickname || "Home"}</p>
            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
              {address.flatNo} , {address.streetName}
            </p>
          </div>
        </div>

        {/* Right */}
        <div className="d-flex align-items-center">
          <div className="form-check form-switch mb-0">
            <input
              type="checkbox"
              className="form-check-input"
              checked={isPrimary}
              onChange={() => updatePrimaryAddress(address.RecordId)}
              disabled={isPrimary}
            />
          </div>
          <label className="small ms-1">{isPrimary ? "Primary Address" : "Other Address"}</label>
        </div>
      </div>

      <hr className="mt-3 mb-2" style={{ marginLeft: "60px", marginRight: "0", borderTop: "1px solid #dee2e6" }} />

      <div className="d-flex gap-3 ms-5">
        <button className="btn btn-link text-primary p-0 d-flex align-items-center text-decoration-none" onClick={() => handleOpenEditModal("Edit", address.RecordId)}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#385986" className="bi bi-pencil" viewBox="0 0 16 16">
            <path d="M12.146.854a.5.5 0 0 1 .708 0l2.292 2.292a.5.5 0 0 1 0 .708l-9.792 9.792a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l9.792-9.792zM11.207 2L13 3.793 14.793 2 13 0.207 11.207 2z" />
            <path d="M1 13.5V16h2.5l9.792-9.792-2.5-2.5L1 13.5z" />
          </svg>
          <span className="ms-1 ff-medium text-primary">Edit</span>
        </button>

        {!isPrimary && (
          <button className="btn btn-link text-danger p-0 d-flex align-items-center text-decoration-none" onClick={() => {
            setSelectedDeleteId(address.RecordId);
            setShowConfirmModal(true);
          }}>
            <img src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg" alt="" />
            <span className="ms-1 ff-medium">Delete</span>
          </button>
        )}
      </div>
    </div>
  );

  if (loading) return <PreLoader />;

  return (
    <>
      <div className="row up-form-r layout-border rounded-3">
        <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2">
          <div>
            <h1 className="ff-semibold text-black mb-1 font-18">My Addresses</h1>
            <p className="font-13 text-muted mb-0">Manage your saved addresses</p>
          </div>
          <div>
            <div className="text-center d-flex justify-content-center col-12 mt-3 mb-5">
              <button className="btn btn-primary text-white bg-main  font-14 ff-regular bt--cart" onClick={() => dispatch(openAddAnotherAddress())}>
                Add New Address
              </button>
            </div>
          </div>
        </div>
        {addresses.length === 0 ? (
          <p>No address found.</p>
        ) : ( 
          <>
            {addresses.some(addr => addr.primaryAddress === 1) && (
              <div className="p-3" style={{ borderRadius: "8px" }}>
                <h6 className="mb-3 fw-bold">Primary Address</h6>
                {addresses
                  .filter(addr => addr.primaryAddress === 1)
                  .map((address) => renderAddressCard(address, true))}
              </div>
            )}

            {addresses.some(addr => addr.primaryAddress !== 1) && (
              <div className="p-3" style={{ borderRadius: "8px" }}>
                <h6 className="mb-3 fw-bold">Other Address</h6>
                {addresses
                  .filter(addr => addr.primaryAddress !== 1)
                  .map((address) => renderAddressCard(address, false))}
              </div>
            )}
          </>
        )}
      </div>
      {showConfirmModal && (
        <DeleteConfirmationModal
          onConfirm={handleDeleteAddress}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
      {showAddAddress && <AddAnotherAddressModel />}
      {showDetailModel && <AddDetailModel />}
      {showAddAddressFromMap && <AddressFromMap />}
    </>
  );
};

export default AddressListing;